/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Agriculture_Environment_Forestry30Inputs */

const en_job_form_enum_agriculture_environment_forestry30 = /** @type {(inputs: Job_Form_Enum_Agriculture_Environment_Forestry30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agriculture, Environment and Forestry`)
};

const de_job_form_enum_agriculture_environment_forestry30 = /** @type {(inputs: Job_Form_Enum_Agriculture_Environment_Forestry30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landwirtschaft, Umwelt und Forstwirtschaft`)
};

/**
* | output |
* | --- |
* | "Agriculture, Environment and Forestry" |
*
* @param {Job_Form_Enum_Agriculture_Environment_Forestry30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_agriculture_environment_forestry30 = /** @type {((inputs?: Job_Form_Enum_Agriculture_Environment_Forestry30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Agriculture_Environment_Forestry30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_agriculture_environment_forestry30(inputs)
	return en_job_form_enum_agriculture_environment_forestry30(inputs)
});
export { job_form_enum_agriculture_environment_forestry30 as "job_form_enum_AGRICULTURE_ENVIRONMENT_FORESTRY" }